import { useAnimation } from "framer-motion";
import { useEffect, useRef } from "react";

export function useMenuContentAnimation(isOpen = false) {
  const controls = useAnimation();
  const ref = useRef(null);

  useEffect(() => {
    controls.start(isOpen ? { opacity: 1, y: 0 } : { opacity: 0.5, y: 20 }, {
      duration: 0.2,
      delay: isOpen ? 0.2 : 0,
    });
  }, [isOpen, controls]);

  return { ref, controls };
}
